import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "../api/apiClient";
import "./Login.css"; // Opprett en egen CSS-fil (valgfritt)

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const response = await apiClient.post("/api/token/", {
        username: username,
        password: password,
      });

      // Lagre token i localStorage
      localStorage.setItem("authToken", response.data.token);

      // Naviger til dashboard etter innlogging
      navigate("/dashboard");
    } catch (error) {
      setError("Ugyldig brukernavn eller passord");
    }
  };

  return (
    <div className="login-container">
      <h1 className="login-title">Logg inn</h1>
      {error && <p className="login-error">{error}</p>}
      <form onSubmit={handleLogin} className="login-form">
        <input
          className="login-input"
          type="text"
          placeholder="Brukernavn"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <input
          className="login-input"
          type="password"
          placeholder="Passord"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button className="login-button" type="submit">
          Logg inn
        </button>
      </form>
    </div>
  );
};

export default Login;